export const DEFAULT_FONT_SIZE = 11;
export const DEFAULT_FONT = 'Palatino';

export const DEFAULT_MARGIN = 10;
